import {
  booleanAttribute,
  Component,
  DestroyRef,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { PlaybackService } from '@splixer/player';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Pv2RoundPlayButtonComponent } from '../../play-buttons/round-play-button.component';
import { ContentMenuItem } from '../../../models';
import { HoursOrMinutesPipe } from '@hidat/ng-common';

@Component({
  selector: 'pv2-playable-list-item',
  templateUrl: 'playable-list-item.component.html',
  styleUrls: ['../../../../styles/content-list.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgStyle,
    NgClass,
    RouterLink,
    Pv2RoundPlayButtonComponent,
    NgTemplateOutlet,
    HoursOrMinutesPipe,
  ],
})
export class Pv2PlayableListItemComponent {
  public item = input.required<ContentMenuItem>();
  public eventSource = input.required<string>();
  public displayPlayButton = input(true, { transform: booleanAttribute });
  public displayDuration = input(true, { transform: booleanAttribute });

  protected playbackService = inject(PlaybackService);
  protected destroyRef = inject(DestroyRef);

  playItem = (event?: Event) => {
    if (event) {
      event.preventDefault();
    }
    const item = this.item();
    if (item.contentId) {
      console.debug('Play ', item.contentId);
      this.playbackService
        .playMix(item.contentId, this.eventSource())
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((res) => {
          console.debug('Started playing ', item.contentId);
        });
    }
  };
}
